(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-highlights-banner"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;
class HighlightsBannerSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;
    this.carousel = new Carousel(this.$root, {
      draggable: true,
      cellAlign: 'left'
    });
    setTimeout(() => {
      this.carousel.onMount();
    }, 100);
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.data.hasSlider || !this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll(`[data-pxu-highlights-banner]`).forEach(($section) => {
  Section.init($section, HighlightsBannerSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.HighlightsBannerSection = HighlightsBannerSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-mosaic"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class MosaicSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;
    this.carousel = new Carousel(this.$root, {
      draggable: true
    });
    setTimeout(() => {
      this.carousel.onMount();
    }, 100);
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.data.hasSlider || !this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-mosaic]').forEach(($section) => {
  Section.init($section, MosaicSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.MosaicSection = MosaicSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-scrolling-images"] && !Shopify.designMode) return;
  try {
    
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

class ScrollingImages extends HTMLElement {
  constructor() {
    super();
    this.paused = false;
  }

  // Section lifecycle

  connectedCallback() {
    this.scrollingImageContent = this.querySelectorAll('[data-scrolling-image-content]'); // wrapper containing images
    if (!this.scrollingImageContent.length) return;
    this.pauseOnHover = this.getAttribute('pause-on-hover') === 'true';
    this.#initScroll();
    this.#handleResize();
    this.#setupTouchClick();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.unobserve(this);
      this.observer = null;
    };
    if (this.ro) {
      this.ro.unobserve(this);
      this.ro = null;
    };
  }

  #handleResize() {
    if (this.ro) return;

    this.ro = new ResizeObserver(
      debounce(() => {
        this.#initScroll();
      }, 50)
    );

    this.ro.observe(this);
  }

  #initScroll() {
    this.scrollingImageContent.forEach((el) => {
      // Get gap from custom element attributes instead of computed style
      const isDesktop = window.matchMedia('(min-width: 480px)').matches;
      const imageGap = parseInt(
        isDesktop 
          ? this.getAttribute('image-gap-desktop') 
          : this.getAttribute('image-gap-mobile'),
        10
      );
      
      const marqueeItems = el.querySelectorAll(
        '[data-scrolling-image-content-item]:not([data-is-clone])'
      );
      
      const width = el.offsetWidth;

      // Calculate the total width of all marquee items using data attributes from individual items
      let totalItemWidth = [...marqueeItems].reduce(
        (total, item) => {
          const itemWidth = parseInt(
            isDesktop 
              ? item.dataset.desktopWidth 
              : item.dataset.mobileWidth,
            10
          );
          return total + (itemWidth + imageGap);
        },
        0
      );


      if (totalItemWidth > 0) totalItemWidth -= imageGap;

      // Ensure we have enough content for smooth infinite scroll (minimum 2 sets)
      const numImageGroups = Math.max(2, Math.ceil((width * 1.5) / Math.max(totalItemWidth, 1)));
      
      // Check how many clone groups we currently have
      const existingClones = el.querySelectorAll('[data-is-clone="true"]');
      const currentCloneGroups = existingClones.length / marqueeItems.length;
      
      // Only modify clones if the required number has changed
      if (Math.floor(currentCloneGroups) !== numImageGroups - 1) {
        // Remove existing clones
        existingClones.forEach(clone => clone.remove());
        
        // Clone and append marquee items if we don't have enough to fill the container
        for (let i = 1; i < numImageGroups; i++) {
          marqueeItems.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('data-is-clone', 'true');
            el.appendChild(clone);
          });
        }
      }

      // Adjust animation duration based on the number of cloned groups to maintain consistent speed
      if (numImageGroups > 1) {
        const originalDuration = parseFloat(getComputedStyle(this).getPropertyValue('--duration'));
        const adjustedDuration = originalDuration * numImageGroups;
        el.style.setProperty('--duration', `${adjustedDuration}s`);
      }
    });

    if (!this.observer) {
      this.#observeAnimations();
    }
  }

  #observeAnimations() {
    // Initiate animations in viewport.
    this.observer = new IntersectionObserver(([entry]) => {
      const { isIntersecting } = entry;
      this.classList.toggle('scrolling-images--is-animated', isIntersecting);
    });
    this.observer.observe(this);
  }

  #setupTouchClick() {
    if (!window.matchMedia('(pointer: coarse)').matches || !this.pauseOnHover) return;
    
    this.addEventListener('click', (e) => {
      this.paused = !this.paused;
      this.scrollingImageContent.forEach((el) => {
        el.style.animationPlayState = this.paused ? 'paused' : 'running';
      });
    });
  }
}

customElements.define('scrolling-images', ScrollingImages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-slideshow"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class SlideshowSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.autoplay = this.data.autoplay;
    this.autoplayDuration = this.data.autoplayDuration * 1000;
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    const options = {
      autoPlay: this.autoplay ? this.autoplayDuration : false,
      prevNextButtons: true,
      lazyLoad: true
    };

    const mobileOptions = {
      draggable: true,
      autoPlay: this.autoplay ? this.autoplayDuration : false,
      lazyLoad: true
    };

    this.carousel = new Carousel(this.$root, options, mobileOptions);
    this.carousel.onMount();
  }

  onUnmount() {
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-slideshow]').forEach(($section) => {
  Section.init($section, SlideshowSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.SlideshowSection = SlideshowSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rise-faq"] && !Shopify.designMode) return;
  try {
    
  function riseFaqInit(root) {
    if (root.dataset.riseFaqReady) return; root.dataset.riseFaqReady = '1';
    var search = root.querySelector('[data-rise-faq-search]');
    var pills = root.querySelectorAll('[data-rise-faq-pill]');
    var groups = root.querySelectorAll('[data-rise-faq-group]');
    var items = root.querySelectorAll('[data-rise-faq-item]');
    var empty = root.querySelector('[data-rise-faq-empty]');
    var viewAll = root.querySelector('[data-rise-faq-viewall]');
    var state = { cat: 'all', q: '', expanded: false };

    function apply() {
      var q = state.q.trim().toLowerCase();
      var anyVisible = false;
      groups.forEach(function (g) {
        var catMatch = state.cat === 'all' || g.dataset.riseFaqGroup === state.cat;
        var groupVisible = 0;
        g.querySelectorAll('[data-rise-faq-item]').forEach(function (it) {
          var hit = !q || it.textContent.toLowerCase().indexOf(q) !== -1;
          var show = catMatch && hit;
          it.hidden = !show;
          if (show) groupVisible++;
          if (q && show) it.querySelector('details').open = true;
        });
        var collapsedByLimit = !state.expanded && state.cat === 'all' && !q && g.classList.contains('is-hidden-initial');
        g.hidden = groupVisible === 0 || collapsedByLimit;
        if (!g.hidden) anyVisible = true;
      });
      if (empty) empty.hidden = anyVisible;
      if (viewAll) viewAll.hidden = state.expanded || state.cat !== 'all' || !!q;
    }
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        state.cat = p.dataset.riseFaqPill;
        pills.forEach(function (o) { var on = o === p; o.classList.toggle('is-active', on); o.setAttribute('aria-selected', on ? 'true' : 'false'); });
        apply();
      });
    });
    if (search) search.addEventListener('input', function () { state.q = search.value; apply(); });
    if (viewAll) viewAll.addEventListener('click', function () { state.expanded = true; apply(); });
    // CSS hides the extra groups before JS runs; from here JS owns the state
    groups.forEach(function (g) { g.classList.remove('is-hidden-initial'); });
    var limit = parseInt(root.dataset.initial, 10) || 0;
    if (limit > 0) { var i = 0; groups.forEach(function (g) { i++; if (i > limit) g.classList.add('is-hidden-initial'); }); }
    apply();
  }
  function riseFaqBoot() { document.querySelectorAll('[data-rise-faq]').forEach(riseFaqInit); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', riseFaqBoot); else riseFaqBoot();
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-rise-faq]').forEach(riseFaqInit); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rise-logo-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var track = root.querySelector('[data-rise-logos-track]');
      var prev = root.querySelector('[data-rise-logos-prev]');
      var next = root.querySelector('[data-rise-logos-next]');
      var dots = root.parentElement.querySelector('[data-rise-logos-dots]');
      if (!track) return;

      function pageWidth() { return track.clientWidth; }
      function pageCount() { return Math.max(1, Math.ceil((track.scrollWidth - 1) / pageWidth())); }
      function currentPage() { return Math.round(track.scrollLeft / pageWidth()); }

      function renderDots() {
        if (!dots) return;
        var n = pageCount();
        dots.innerHTML = '';
        if (n < 2) return;
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rise-logos__dot';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Page ' + (i + 1));
          b.dataset.page = i;
          b.addEventListener('click', function (e) { goTo(parseInt(e.currentTarget.dataset.page, 10)); });
          dots.appendChild(b);
        }
        update();
      }
      function update() {
        var p = currentPage(), n = pageCount();
        if (prev) prev.disabled = p <= 0;
        if (next) next.disabled = p >= n - 1;
        if (dots) Array.prototype.forEach.call(dots.children, function (d, i) { d.setAttribute('aria-selected', i === p ? 'true' : 'false'); });
      }
      function goTo(p) { track.scrollTo({ left: p * pageWidth(), behavior: 'smooth' }); }

      if (prev) prev.addEventListener('click', function () { goTo(currentPage() - 1); });
      if (next) next.addEventListener('click', function () { goTo(currentPage() + 1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentPage() + 1); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(currentPage() - 1); }
      });
      var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(renderDots, 150); });
      renderDots();

      // Autoplay: advance one page every N seconds, loop, pause while hovered/focused/touched
      var delay = parseInt(root.getAttribute('data-autoplay') || '0', 10) * 1000;
      if (delay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var timer = null, paused = false;
        function tick() { if (paused || document.hidden) return; var p = currentPage(), n = pageCount(); goTo(p >= n - 1 ? 0 : p + 1); }
        function start() { stop(); timer = setInterval(tick, delay); }
        function stop() { if (timer) { clearInterval(timer); timer = null; } }
        ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (e) { root.addEventListener(e, function () { paused = true; }, { passive: true }); });
        ['mouseleave', 'focusout', 'touchend', 'pointerup'].forEach(function (e) { root.addEventListener(e, function () { paused = false; }, { passive: true }); });
        document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
        start();
      }
    }
    function boot() { document.querySelectorAll('[data-rise-logos]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-rise-logos]').forEach(init); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rise-pro-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var btn = root.querySelector('[data-rise-ph-play]'), modal = root.querySelector('[data-rise-ph-modal]');
    if (!btn || !modal) return;
    var iframe = modal.querySelector('iframe');
    function open() { iframe.src = iframe.getAttribute('data-src'); modal.hidden = false; document.body.style.overflow = 'hidden'; modal.querySelector('[data-rise-ph-close]').focus(); }
    function close() { modal.hidden = true; iframe.src = ''; document.body.style.overflow = ''; btn.focus(); }
    btn.addEventListener('click', open);
    modal.querySelectorAll('[data-rise-ph-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }
  function boot() { document.querySelectorAll('[data-section-type="rise-pro-hero"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-section-type="rise-pro-hero"]').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rise-related-info"] && !Shopify.designMode) return;
  try {
    
(function () {
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); };
  var ARROW = '<span class="rise-rg__arrow" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></span>';

  function card(item, variant, pillText) {
    var summary = item.summary || item.description || '';
    var img = item.thumbnail_url || item.image || '';
    return '<article class="rise-rg__card rise-rg__card--' + variant + '">' +
      '<div class="rise-rg__bg" style="background-image:url(\'' + esc(img) + '\')"></div>' +
      '<a class="rise-rg__link" href="' + esc(item.url) + '" target="_blank" rel="noopener">' +
        (pillText ? '<span class="rise-rg__pill">' + esc(pillText) + '</span>' : '') +
        '<h3 class="rise-rg__card-title">' + esc(item.title) + '</h3>' +
        (summary ? '<p class="rise-rg__excerpt">' + esc(summary) + '</p>' : '') +
        ARROW +
      '</a></article>';
  }

  function categoryOf(a) { return a.category || a.type || a.kind || (Array.isArray(a.tags) ? a.tags[0] : '') || 'Guide'; }

  function init() {
    var tagEl = document.querySelector('script[data-section-type="rise-related-info"]');
    var root = document.querySelector('[data-rise-rg]');
    var grid = document.querySelector('[data-rise-rg-grid]');
    if (!tagEl || !root || !grid) return;
    var tag = tagEl.getAttribute('data-section-id');
    if (!tag) return;

    fetch('https://d3990iwfnglr0g.cloudfront.net/related-by-tag?tags=' + encodeURIComponent(tag), { mode: 'cors' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        var products = data.products || [], articles = data.articles || [];
        if (products.length) articles = articles.slice(0, 4);
        var items = products.map(function (p) { return { item: p, pill: 'Product' }; })
          .concat(articles.map(function (a) { return { item: a, pill: categoryOf(a) }; }));
        if (!items.length) return;
        var total = items.length;
        if (total < 4) grid.classList.add('rise-rg__grid--few');
        else if (total === 4) grid.classList.add('rise-rg__grid--four');
        grid.innerHTML = items.map(function (x, i) {
          var variant = (total >= 5 && (i === 0 || i === 3)) || total < 5 ? 'large' : 'small';
          return card(x.item, variant, x.pill);
        }).join('');
        root.hidden = false;
      })
      .catch(function () { root.hidden = true; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rise-text-feature"] && !Shopify.designMode) return;
  try {
    
  function riseReviewsInit(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var track = root.querySelector('[data-rise-reviews-track]');
    var dots = root.querySelector('[data-rise-reviews-dots]');
    var minRating = parseFloat(root.dataset.minRating) || 0;
    var max = parseInt(root.dataset.max, 10) || 8;
    var autoplay = (parseInt(root.dataset.autoplay, 10) || 0) * 1000;
    var items = [], index = 0, timer = null, built = false, harvested = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function star() { return '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.9 6.9 7.1.6-5.4 4.7 1.7 7-6.3-3.8L5.7 21.2l1.7-7L2 9.5l7.1-.6z"/></svg>'; }
    function esc(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }
    function clampRating(r) { r = Math.round(Number(r)); if (!isFinite(r) || r < 0) return 0; return r > 5 ? 5 : r; }
    function render(list) {
      items = list.slice(0, max);
      if (!items.length) { root.setAttribute('data-empty', ''); return; }
      root.removeAttribute('data-empty');
      track.innerHTML = items.map(function (r, i) {
        var n = clampRating(r.rating);
        var stars = n ? '<span class="rise-tf__review-stars">' + Array(n + 1).join(star()) + '</span>' : '';
        return '<blockquote class="rise-tf__review' + (i === 0 ? ' is-active' : '') + '">' + stars +
          '<p class="rise-tf__review-body">' + esc(r.body) + '</p>' +
          '<footer><span class="rise-tf__review-author">' + esc(r.author || 'Verified customer') + '</span>' +
          (r.meta ? '<span class="rise-tf__review-meta">' + esc(r.meta) + '</span>' : '') + '</footer></blockquote>';
      }).join('');
      dots.innerHTML = items.map(function (_, i) { return '<button class="rise-tf__reviews-dot' + (i === 0 ? ' is-active' : '') + '" type="button" aria-label="Review ' + (i + 1) + '"></button>'; }).join('');
      dots.querySelectorAll('button').forEach(function (b, i) { b.addEventListener('click', function () { go(i); restart(); }); });
      index = 0; built = true; restart();
    }
    function go(i) {
      if (!items.length) return;
      index = (i + items.length) % items.length;
      track.querySelectorAll('.rise-tf__review').forEach(function (el, k) { el.classList.toggle('is-active', k === index); });
      dots.querySelectorAll('button').forEach(function (el, k) { el.classList.toggle('is-active', k === index); });
    }
    function restart() { if (timer) clearInterval(timer); if (autoplay && !reduce && items.length > 1) timer = setInterval(function () { go(index + 1); }, autoplay); }
    root.querySelector('[data-rise-reviews-prev]').addEventListener('click', function () { go(index - 1); restart(); });
    root.querySelector('[data-rise-reviews-next]').addEventListener('click', function () { go(index + 1); restart(); });
    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    var sx = null;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); restart(); } sx = null; }, { passive: true });

    function decode(t) { if (/%[0-9A-Fa-f]{2}/.test(t)) { try { return decodeURIComponent(t); } catch (e) { return t; } } return t; }
    function textOf(el) { return el ? decode(el.textContent.trim().replace(/\s+/g, ' ')) : ''; }

    // Harvest from the Judge.me cards carousel once its JS has rendered it
    var source = root.querySelector('[data-rise-reviews-source]');
    function harvest() {
      if (harvested || !source) return false;
      var cards = source.querySelectorAll('.jdgm-carousel-item, .jdgm-card, .jdgm-rev');
      if (!cards.length) return false;
      var list = [], seen = {};
      cards.forEach(function (c) {
        if (c.hasAttribute('data-clone-type')) return;
        var id = c.getAttribute('data-review-id');
        if (id) { if (seen[id]) return; seen[id] = true; }
        var text = textOf(c.querySelector('.jdgm-text'));
        if (!text) return;
        var author = textOf(c.querySelector('.jdgm-reviewer-name'));
        var product = textOf(c.querySelector('.jdgm-product-name'));
        var score = c.querySelectorAll('.jdgm-rating-section .jdgm-star.jdgm--on').length;
        if (!score) { var ds = c.querySelector('[data-score]'); if (ds) score = parseFloat(ds.getAttribute('data-score')); }
        var known = isFinite(score) && score > 0;
        if (known && score < minRating) return;
        list.push({ body: text, author: author, meta: product, rating: known ? score : 0 });
      });
      if (!list.length) return false;
      try { render(list); harvested = true; return true; } catch (e) { return false; }
    }
    function fallback() {
      if (built) return;
      try { var raw = root.querySelector('[data-rise-reviews-fallback]'); var list = JSON.parse(raw ? raw.textContent : '[]'); render(list.filter(function (r) { return r && r.body; })); }
      catch (e) { root.setAttribute('data-empty', ''); }
    }
    if (source && !harvest()) {
      var mo = new MutationObserver(function () { if (harvest()) mo.disconnect(); });
      mo.observe(source, { childList: true, subtree: true, attributes: true });
      // show curated testimonials quickly, but let real reviews replace them when Judge.me finishes loading
      setTimeout(function () { if (!harvested) fallback(); }, 3000);
      setTimeout(function () { mo.disconnect(); if (!built) fallback(); }, 30000);
    } else if (!source) { fallback(); }
  }
  function riseReviewsBoot() { document.querySelectorAll('[data-rise-reviews]').forEach(riseReviewsInit); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', riseReviewsBoot); else riseReviewsBoot();
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-rise-reviews]').forEach(riseReviewsInit); });

  } catch(e) { console.error(e); }
})();
})();
